import { Typography } from '@mui/material'
import { useTranslate, useShowContext } from 'react-admin'
import React from 'react'
import AddressDetails from './Address.details'
import { CertificateOut } from '../../../types/apiRequests'
import { getInstance } from '../../../utils/getInstance'
import { getKoppelvlak } from '../../../utils/getKoppelvlak'
import { getCommonName } from '../../../utils/getCommonName'

export interface CertificateMetaData {
  commonName?: string
  instanceId?: string
  samlKoppeling?: string
}

const ZakenDetails: React.FC = () => {
    const translate = useTranslate()
    const { record } = useShowContext<CertificateOut>()

    const meta = record?.metaData as CertificateMetaData
    const samlType = meta?.samlKoppeling
    return (
        <>
            <Typography variant="subtitle1" sx={{ marginTop: '20px', marginBottom: '10px' }}>
                <span>{translate('resources.certificates.fields.properties')}</span>
            </Typography>
             <AddressDetails
                title={translate('resources.certificates.fields.instance')}
                value={getInstance(record)}
            />
            <AddressDetails
                title={translate('resources.certificates.fields.kind')}
                // Without a samlKoppeling the raw i18n key would be shown.
                value={samlType ? translate(`resources.certificates.fields.${samlType}`) : '-'}
            />
            <AddressDetails
                title={translate('resources.certificates.fields.interface')}
                value={getKoppelvlak(record)}
            />
            <AddressDetails
                title={translate('resources.certificates.fields.host')}
                value={getCommonName(record)}
            />
        </>
    )
}

export default ZakenDetails